import React from "react";
import Axios from "axios";

import Navbar from "./components/Navbar/Navbar";
import Column from "./components/Column/Column";

export default class App extends React.Component {
	state = {
		todos: {
			title: "کار هایی که باید انجام دهم",
			items: [],
			category: "todo",
		},
		routines: {
			title: "کار های روتین",
			items: [],
			category: "routine",
		},
		goals: {
			title: "اهداف این هفته من",
			items: [],
			category: "goal",
		},
	};

	componentDidMount() {
		Axios.get("http://sys.niroomohareke.ir/backend/api/index")
			.then((response) => {
				const prevTodos = this.state.todos;
				const prevRoutines = this.state.routines;
				const prevGoals = this.state.goals;
				this.setState({
					todos: { title: prevTodos.title, items: response.data.todos, category: prevTodos.category },
					routines: { title: prevRoutines.title, items: response.data.routines, category: prevRoutines.category },
					goals: { title: prevGoals.title, items: response.data.goals, category: prevGoals.category },
				});
			})
			.catch((error) => console.error(error));
	}

	render() {
		return (
			<div className="p-4 flex flex-col items-center">
				<div className="container ">
					<Navbar />
					<main className="flex flex-col md:flex-row md:-mx-2">
						<Column content={this.state.todos} />
						<Column content={this.state.routines} />
						<Column content={this.state.goals} />
					</main>
				</div>

				<footer className="md:py-10 flex items-end py-4 text-center">
					<p>توسعه دهنده: آریا سیداحمدی</p>
				</footer>
			</div>
		);
	}
}
